import { ReactNode, createContext, useState } from 'react'

import { filterArrayWithIndex } from '@/common/util/array'
import { ChildProps } from '@/common/util/props'
import { TOAST_INTERVAL_MILI, onceTimer } from '@/common/util/timer'

import MessageBarList from '@/components/view/layouts/bar/MessageBarList'
import MessageBar, { MessageType } from '@/components/view/molecules/bar/MessageBar'

interface ToastMessage {
  text: string | ReactNode
  type: MessageType
}

interface ToastMessageState {
  messages: ToastMessage[]
  addMessage(message: { text: string | ReactNode; type: MessageType }): void
}

const defaultValue: ToastMessageState = {
  messages: [],
  addMessage: () => {}
}

export const ToastMessageContext = createContext<ToastMessageState>(defaultValue)

const ToastMessageProvider = ({ children }: ChildProps) => {
  const [messages, setMessages] = useState<ToastMessage[]>([])
  const addMessage = (message: { text: string; type: MessageType }) => {
    setMessages((messages) => [...messages, message])
    onceTimer(() => {
      setMessages((messages) => messages.slice(1))
    }, TOAST_INTERVAL_MILI)
  }

  return (
    <ToastMessageContext.Provider
      value={{
        messages: [],
        addMessage
      }}
    >
      {children}

      {messages.length > 0 && (
        <MessageBarList toast>
          {messages.map((message, index) => (
            <MessageBar
              key={index}
              type={message.type}
              onClickClose={() => setMessages((messages) => filterArrayWithIndex(messages, index))}
              toast
            >
              {message.text}
            </MessageBar>
          ))}
        </MessageBarList>
      )}
    </ToastMessageContext.Provider>
  )
}

export default ToastMessageProvider
